import script from "./DataLibraryView.vue?vue&type=script&setup=true&lang=js"
export * from "./DataLibraryView.vue?vue&type=script&setup=true&lang=js"

import "./DataLibraryView.vue?vue&type=style&index=0&id=56e8c8fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56e8c8fc"]])

export default __exports__